import { Injectable } from "@angular/core";
import { SecurityMasterGridLayoutService } from '@irb/irb-models/security-master/security-master.grid-layout.service';
import { lightningIconCellComponent } from "../delete-conditional.cell.component";
import { SelectMultiplePortfoliosDialogComponent } from "./select-multiple-portfolios-dialog.component";
import {PortfolioLabelsService} from '@irb/irb-clients/portfolios/portfolios.labels.service';
import { DropdownSearchMultipleRendererComponent } from '@irb-common/components/grid/renderers/dropdown-search-multiple.cell.component';
import { GridLayoutService } from '@irb-common/interfaces/grid-layout.service';

@Injectable({
    providedIn: "root" 
})
export class SelectMultiplePortfoliosGridService implements GridLayoutService<SelectMultiplePortfoliosDialogComponent> {

    constructor(private smgls: SecurityMasterGridLayoutService, private pls: PortfolioLabelsService) {}

    getFrameworkComponents() {
        return {
            "DropdownSearchMultipleRendererComponent": DropdownSearchMultipleRendererComponent,
            "lightningIconCellComponent":lightningIconCellComponent
        };
    }

    getColumnDefs(parent: SelectMultiplePortfoliosDialogComponent) {
        const columns: any = [
            {
                headerName: '',
                children: [{
                    headerName: 'Select All',
                    colId: 'selectAll',
                    headerComponent: 'customHeader',
                    cellRendererSelector: function (params:any) {
                        let lightningicon= {
                            component:'lightningIconCellComponent'
                        }
                        let selectCellComponent = {
                            component: 'customHeader',
                            params: {parentObject: parent, type: 'rowCheckBox', isDisabled: parent.isDisabled}
                        };
                        if (parent.getSmartFilteredPortfolios(params.data)) {
                            return lightningicon ;
                        } else {
                            return selectCellComponent;
                        }
                    }.bind(parent),
                    suppressColumnsToolPanel: true,
                    suppressFiltersToolPanel: true,
                    suppressSizeToFit: true,
                    toolPanelClass: 'toolpanel-header-checkbox-hide',
                    headerComponentParams: {parentObject: parent, type: 'headerCheckBox'},
                    floatingFilterComponent: 'customHeader',
                    floatingFilterComponentParams: {parentObject: parent, type: 'clearAllBtn'},
                    suppressFloatingFilterButton: true,
                    pinned: 'left',
                    suppressMovable: true,
                    lockPosition: true,
                    lockVisible: true,
                    sortable: false,
                    filter: true,
                    resizable: true,
                    minWidth: 25,
                    width: 25,
                    maxWidth:25,
                    cellStyle: {'padding': '5px 3px 0 2px'},
                    headerClass: 'customHeaderClassSelectAll',
                    cellClass: 'selectAllCheckBoxRecord'
                }]
            },
            {
                headerName: 'Portfolios',
                children: [
                    {
                        headerName: 'Name',
                        colId: 'portfolioName',
                        field: 'portfolioName',
                        lockPosition: true,
                        lockVisible: true, 
                        flex: 3,
                        sort: 'asc',
                        suppressFloatingFilterButton: true,
                        filter: 'agTextColumnFilter',
                        filterParams: {
                            clearButton: true,
                            debounceMs: 1000,
                            textFormatter: this.portfolioFilterFormatter,
                            maxNumConditions: 1,
                            values: (params: any) => {
                                params.success(parent.modelNames);
                            }
                        },
                        cellRenderer: 'cellRendererFormatter',
                        cellRendererParams: {
                            columnToolTipInfo: this.smgls.cashSecurity(),
                        }
                    },
                    {
                        headerName: parent.customCategotyColumnHeader,
                        headerValueGetter: () => parent.customCategotyColumnHeader,
                        colId: 'labels',
                        field: 'labels',
                        sortable: false,
                        suppressFiltersToolPanel: true,
                        floatingFilterComponent: 'irbInputFloatingFilterComponent',
                        filter: 'irbAgSearchMultipleColumnFilterComponent',
                        filterParams: (_params: any) => {
                            return {
                                values: [{name: '(none)', value: 'uncategorized'}].concat(this.pls.getDropdownOptionsForLabels(this.pls.portfolioLabels)),
                                enableHiddenSearchResults: false,
                                enableEmptySearchTerm: true,
                                noOptionsTemplate: parent.noOptionsTemplate
                            }
                        },    
                        flex: 1,
                        cellClass: 'dropdownSearchMultipleCell',
                        cellRenderer: 'DropdownSearchMultipleRendererComponent',
                        cellRendererParams: (params: any) => {
                            return {
                                defaultValue: this.pls.getDropdownOptionsForLabels(params.data.labels),
                                cellStyle: "labels",
                                canEdit: false,
                                hiddenLabelPanelTitle: parent.customCategotyColumnHeader
                            };
                        }
                    },
                    {
                        headerName: 'Model',
                        field: 'securityModelName',
                        filter: 'agSetColumnFilter',
                        filterParams: {
                            buttons: ['reset', 'apply'],
                            values: (params: any) => {
                                params.success(parent.modelNames);
                            },
                            newRowsAction: 'keep',
                            suppressSorting: true,
                            closeOnApply: true,
                            cellHeight: 30
                        },
                        flex: 1,
                    },
                    {
                        headerName: 'Market Value',
                        colId: 'totalPortfolioValue',
                        field: 'totalPortfolioValue',
                        cellRenderer: 'cellRendererFormatter',
                        cellRendererParams: {type: 'currency', displaySymbol: ' '},
                        maxWidth: 200,
                        flex: 1
                    },
                    ]
            },
           
        ];
        return columns;
    }
    portfolioFilterFormatter(r: any) {
        if (r == null) { return null; }
        return r;
    }

    isDisableCheckBox(data: any) {
        if (data) {
            const approvStatus = data.authStatus;
            if (approvStatus === "Unauthorized") {
                return true;
            }
        }
        return false;
    }

    isDisabled(data: any) {
        return this.isDisableCheckBox(data);
      }

}
